<template>
  <table class="table table-hover table-responsive-lg">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Dept. Name</th>
        <th>Dept. Number</th>
        <th>FERPA</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="user in users.sort((a, b) => a.cn.localeCompare(b.cn))"
        :key="user.emplId"
      >
        <td class="pl-3">
          <strong>{{ user.cn }}</strong>
        </td>
        <td>{{ user.mail }}</td>
        <td>{{ user.employeePrimaryDeptName }}</td>
        <td>{{ user.employeePrimaryDept }}</td>
        <td>{{ user.employeeIsFerpaTrained || "N" }}</td>
        <td>{{ getUserStatus(user) }}</td>
        <td class="d-flex justify-content-end">
          <div class="btn-group">
            <button
              class="btn btn-primary"
              title="Approve"
              aria-label="Approve"
              @click="approveRequest(user)"
            >
              <span aria-hidden>✓</span>
            </button>
            <button
              class="btn btn-danger"
              title="Deny"
              aria-label="Deny"
              @click="denyRequest(user)"
            >
              <span aria-hidden>⨉</span>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    users: { required: true, type: Array },
  },
  methods: {
    approveRequest(user) {
      this.$emit("update-user", { ...user, roles: ["user"] })
    },
    denyRequest(user) {
      this.$emit("delete-user", user)
    },
    getUserStatus(user) {
      const {
        eduPersonPrimaryAffiliation,
        dccPrimaryStatus,
        employeeStatus,
      } = user
      if (eduPersonPrimaryAffiliation === "dcc") return dccPrimaryStatus || "-"
      return employeeStatus || "-"
    },
  },
}
</script>

<style></style>
